module.exports = __webpack_public_path__ + "static/media/blny.6c8c664a.jpg";